import MarkdownRenderer from "../../../markdown-renderer";
import {
  FormResponseComponent,
  UserConversationRoleEnum,
} from "@aichat/types/index";
import { MessageContainerProps } from "../message-container";

type FormResponseType = {
  formResponse: FormResponseComponent;
  role: UserConversationRoleEnum;
  widgetConfig: MessageContainerProps["widgetConfig"];
};
const FormResponse = ({
  formResponse,
  role,
  widgetConfig,
}: FormResponseType) => {
  const markdown = getFormResponseMarkdown(formResponse);

  return (
    <MarkdownRenderer role={role} widgetConfig={widgetConfig} text={markdown} />
  );
};

export default FormResponse;

function getFormResponseMarkdown(formResponse: FormResponseComponent): string {
  const lines: string[] = ["**Form Response**", ""];
  for (const [key, field] of Object.entries(formResponse)) {
    const label = key.replace(/_/g, " ");
    const value = Array.isArray(field.value)
      ? field.value.join(", ")
      : String(field.value);
    lines.push(`- ${label}: ${value}`);
  }
  return lines.join("\n");
}
